import { Auth, ContentDetailsPage } from 'components'

export const Add = () => {
  return (
    <Auth>
      <ContentDetailsPage />
    </Auth>
  )
}
